import { Component, OnInit, isDevMode } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { ErrorHandlerService } from '../../services/error-handler.service';
import { HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { ApiService } from '../../services/api.service';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { FusionButtonComponent } from 'src/app/components/fusion-button/fusion-button.component';
import { Constants } from 'src/app/models/Constants';
import { AlertService } from 'src/app/services/alert.service';
import { Subscription } from 'rxjs';
import { FusionFrameworkService } from 'src/app/services/fusion-framework.service';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner'; //SK 9JAN24

@Component({

  selector: 'app-login',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule,AngularSvgIconModule,FusionButtonComponent, NgxSpinnerModule],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent implements OnInit {

  currentApplicationVersion = environment.appVersion;
  public errorMessage: string | undefined = undefined;
  public fpMailError: string | undefined = undefined;
  loginForm!: FormGroup;
  fpForm!: FormGroup;
  buttonDisable = false;
  loginButton = "login-button button-disabled";
  fpButton = "fp-button button-disabled";
  error = '';
  errorMsg = false;
  
  errorPasswordMsg = false;
  passWorderror = '';
  validRegex = "[A-Za-z0-9._%-+]+@[A-Za-z0-9._%-]+\\.[a-z]{2,10}";
  loginScreen = true;
  showResetFields = true;
  passwordHide = false;
  rememberMeChecked = '';
  getData: Object | undefined;
  pageComponentName = 'Login';
  isDevMode: boolean = false;
  successMsg = Constants.SUCCESS_MESSAGE;

  shouldDisplayFusionAppLogo: boolean = false;
  shouldDisplayValarhrAppLogo: boolean = false;
  domain:any;
  // jsonSubscription: Subscription; // THIS CODE TO BE USED IN FUTURE FOR JSON BASED FRAMEWORK. DON'T REMOVE IT
  configJSON: any;
  typeSelected! : string;
  languageCode = "en-US"; //SK24JUN24
  constructor(private apiService:ApiService, private fb: FormBuilder, private authService: AuthService, private router: Router, private errorHandler: ErrorHandlerService, private alertService: AlertService, private fusionFrameWork: FusionFrameworkService, private spinnerService: NgxSpinnerService) { 
    this.isDevMode = isDevMode();
    this.typeSelected = 'ball-spin-clockwise-fade';  //SK 9JAN24 loader type in login
    // THIS CODE TO BE USED IN FUTURE FOR JSON BASED FRAMEWORK. DON'T REMOVE IT
    // this.jsonSubscription = this.fusionFrameWork.appJSONData$.subscribe((type:any) => {
    //   this.configJSON = type.appConfig;
    //   this.redirectUrl = this.configJSON[0]?.reDirectURL;
    // });

    // SK24JUN24 getting lang code from local
    const userData = JSON.parse(localStorage.getItem('userData') as any);
    if(userData) {
      this.languageCode = userData.languageCode || "en-US";
    }
  }

  ngOnInit(): void {
    
     // To display logo dynamiclly
    const currentURL = window.location.href;
    //To extract the domain from URL;
    this.domain = currentURL.split('.')[1]+'.'+currentURL.split('.')[2];
    if (this.domain.includes('valarhr.com')) {
      this.shouldDisplayValarhrAppLogo = true;
    } else {
      this.shouldDisplayFusionAppLogo = true;
    }

    this.loginForm = this.fb.group({
      'username': [localStorage['username'] == null ? '' : localStorage['username'], Validators.compose([Validators.required, Validators.pattern(this.validRegex)])],
      'password': [null,Validators.compose([Validators.required, Validators.minLength(6), Validators.maxLength(30)]) ],
      'rememberMe': [localStorage['checkbox']]
    });

    this.fpForm = this.fb.group({
      'email': [null, Validators.compose([Validators.pattern(this.validRegex), Validators.required])]
    });

    this.rememberMeChecked = localStorage['checkbox'] == '' ? '' : localStorage['checkbox'];
  }

  handlePasswordChange(event: any): void {
    this.loginForm.value.password = event.target.value;
    if (this.loginForm.value.password.length > 5 && this.loginForm.value.password.length < 30 || this.loginForm.value.password.length === 0) {
      this.errorPasswordMsg = false;
      this.passWorderror = '';
    } else {
      this.errorPasswordMsg = true;
      this.passWorderror = 'passWorderror';
    }
  }

  handleRememberMeChange(event: any) {
    this.loginForm.value.rememberMe = event.target.checked;
  }

  settingsData:any;
  localizationdata:any;
  salaryData:any;
  emailData:any;

  handleLoginClick() {
    const localUrl = localStorage.getItem("routerURL"); //SK10AUG24
    localStorage.clear(); //SK12FEB24 clearing the localStorage while login, to avoid previous cache
    // this.spinnerService.show();  //SK 9JAN24 loader show function
    if(this.isDevMode) console.log("handleLoginClick");
    this.errorMessage = '';
    if (this.loginForm.value.username !== "") {
      localStorage.setItem('username', this.loginForm.value.username);
    } else {
      localStorage.setItem('username', "");
    };

    if (this.loginForm.value.rememberMe) {
      localStorage['checkbox'] = this.loginForm.value.rememberMe;
    } else {
      localStorage['checkbox'] = null;
    }

    const val = this.loginForm.value;
    // Check if the form is filled with valid values , if so proceed to login else just skip form submission
    if (this.loginForm.invalid) {
      return;
    }
    
    if (val.username && val.password) {
      this.authService.login(val.username, val.password)
        .subscribe({
          next: (v) => {
            // this.spinnerService.hide();  //SK 9JAN24 loader hide function
            if(this.isDevMode) console.log("Next :", v);
            if(this.isDevMode) console.log("User signedup in");
            let usr = JSON.parse(window.atob(v.token.split('.')[1]));
            let roles = (usr.permissions);
            // SK21DEC23 dynamic fusion color module while login
            if(v?.theme){
              document.documentElement.style.setProperty('--fusion-color', v.theme?.fusionColor);
              document.documentElement.style.setProperty('--module', v.theme?.clrBody);
              document.documentElement.style.setProperty('--active-module', v.theme?.fcSubLite);
              document.documentElement.style.setProperty('--active-module-bg', v.theme?.fcPrimaryColor);
            }
            this.errorMessage = '';
            // SK24JUN24 lang code routing in settings, hrm, ess
            if(localUrl!= null){
              this.router.navigateByUrl(localUrl);
            } else {
              if(roles.includes('Super User') && this.settingsData === undefined && this.salaryData === undefined && this.localizationdata == undefined && this.emailData === undefined) {
                //SKS11DEC24 If the address field is null, undefined, or empty, navigates to the settings page with the specified language code and query parameter.
                this.apiService.fetchValue('/user').subscribe((data: any) => {
                  let addrField: string | undefined = undefined;
                  data?.settings?.forEach((responseData: any) => {
                    addrField = responseData.address1;
                  });

                  //SKS12DEC24 Check addrField after API response
                  if (addrField === null || addrField === undefined || addrField === '') {
                    this.router.navigate(['/settings', this.languageCode || "en-US"], {
                      queryParams: {
                        pageFrom: 'login'
                      }
                    });
                  } else {
                    //SKS12DEC24 Continue with other conditions
                    this.handleRoleBasedNavigation(roles, usr);
                  }
                })
              } else {
                this.handleRoleBasedNavigation(roles, usr);
              }
            } 
          },
          error: (err: HttpErrorResponse) => {
            // this.spinnerService.hide();  //SK 9JAN24
            if(this.isDevMode) console.log("Login Error", err);
            this.errorHandler.handleError(err);
            this.errorMessage = this.errorHandler.errorMessage;
            this.alertService.messageOnPass('error', this.errorMessage);
          }
        });
    }
  }
  //SKS12DEC24 handle Role Based Navigation
  handleRoleBasedNavigation(roles: string[], usr: any) {
    if ((roles.includes('Super User') && !usr.defaultApp) || (roles.includes('HRM User') && !usr.defaultApp) || (roles.includes('HRM Manager') && !usr.defaultApp)) {
      this.router.navigateByUrl('/hrm/'+this.languageCode || "en-US");
    } else if (roles.includes('ESS User') && !usr.defaultApp) {
      this.router.navigateByUrl('/ess/' + (this.languageCode || "en-US"));
    } else {
      this.router.navigateByUrl('/app/' + (this.languageCode || "en-US") + usr.defaultApp);  // MR 07DEC23 replaced /app/parking/home/entries_button with /app
    }
  }
  sendPasswordLink() {
    this.fpMailError= '';
    const val = this.fpForm.value;
    // Check if the form is filled with valid values , if so proceed to login else just skip form submission
    if (this.fpForm.invalid) {
      return;
    }
    /*else {
      this.showResetFields = false;
    }*/
    if (val.email) {
      this.apiService.writeValue('post','/forgotpassword',{'email':val.email,'source':this.domain.split('/')[0]})
      .subscribe({
        next: (v) => {
          if(this.isDevMode) console.log("Next :", v);
          if(this.isDevMode) console.log("Mail Sent");
          this.fpMailError = '';
          this.showResetFields = false;
          this.alertService.messageOnPass('success', 'Password reset mail sent successfully');
        },
        error: (mailErr: HttpErrorResponse) => {
          this.errorHandler.handleError(mailErr);
          this.fpMailError = this.errorHandler.errorMessage;
          this.showResetFields = true;
          this.alertService.messageOnPass('error', this.fpMailError);
        }
      });
    }
  }

  validateInput(event: any) {
    this.loginForm.value.username = event.target.value;
    if (event.target.value.match(this.validRegex) || event.target.value === '') {
      this.error = '';
      this.errorMsg = false;
         } 
    else {
      this.errorMsg = true;
      this.error = 'inputError';
    }
  }
}